import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, InputEventHandler, InputHTMLAttributes } from 'react';
import css from './style.module.scss';
interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
  value?: string;
}
const adjustHeight: InputEventHandler<HTMLTextAreaElement> = event => {
  const textarea = event.target as HTMLTextAreaElement;
  textarea.style.height = '40px';
  textarea.style.height = textarea.scrollHeight + 'px';
};
const Textarea: FC<Props> = t0 => {
  const $ = _c(11);
  const {
    placeholder,
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = event => {
      adjustHeight(event);
      onChange?.(event);
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleInput = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx(css.field, css.textarea);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== handleInput || $[4] !== onChange || $[5] !== placeholder || $[6] !== value) {
    t3 = <textarea value={value} placeholder={placeholder} className={t2} onInput={handleInput} onChange={onChange} />;
    $[3] = handleInput;
    $[4] = onChange;
    $[5] = placeholder;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = <div className={css.fieldWrapper}>{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default Textarea;